/**
 * Получаем объект с полями формы
 * @param form
 */
export default function getFormFileds(form: FormData) {
  const formData: any = {};

  form.forEach((value, key) => {
    if (formData[key]) {
      if (!Array.isArray(formData[key])) {
        formData[key] = [formData[key]];
      }
      formData[key].push(value);
    } else {
      formData[key] = value;
    }
  });

  return formData;
}
